import { useEffect,useState } from "react";

const sessionStorageKeywords = {
  notificationUrl: "notificationUrl",
}

const useSessionStorage = (key: string, defaultValue: string | null = null) => {
  const [storedValue, setStoredValue] = useState<string | null>(null);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const value = sessionStorage.getItem(key);
      setStoredValue(value ?? defaultValue);
    }
  }, [key, defaultValue]);

  const setValue = (value: string | null) => {
    if (value === null) {
      sessionStorage.removeItem(key);
      setStoredValue(null);
    } else {
      sessionStorage.setItem(key, value);
      setStoredValue(value);
    }
  };

  return [storedValue, setValue] as const;
};

export {sessionStorageKeywords, useSessionStorage};
